import styled from "styled-components";
import Icon from "../../../../../../../components/icon";
import { theme } from "../../../../../../../helpers/theme";
import { ReactComponent as ResignationIconSVG } from "../../../../../../../assets/icons/resignation-icon.svg";
import { useNavigate, useParams } from "react-router-dom";
import { OfferClientPreRefuseRequestBody } from "../../../../../../../services/offers/offer-client-pre-refuse/types";
import { useMutation } from "@tanstack/react-query";
import { urlClient } from "../../../../../../../utils/url";
import { offerClientPreRefuse } from "../../../../../../../services/offers/offer-client-pre-refuse";
import SessionService from "../../../../../../../services/session-service";
import { offerClientFinalRefuse } from "../../../../../../../services/offers/offer-client-final-refuse";
import { OfferClientFinalRefuseRequestBody } from "../../../../../../../services/offers/offer-client-final-refuse/types";
import { LoadingBackDrop } from "../../../../../../../components/loader";
interface ResignationBarProps {
    id_zamowienia: string,
    oferta_id: string,
    isFinalOffer?:boolean,
}


export const ResignationBar = ({ id_zamowienia, oferta_id, isFinalOffer }: ResignationBarProps) => {

    const navigate = useNavigate();
    const user = SessionService.getUser();
    const isLoged = user && user.token_dostepu !== null ? true : false;

    const offerClientPreRefuseMutation = useMutation(offerClientPreRefuse, {
        onSuccess: (res) => {
            SessionService.clearOrderIdentification();
            navigate('/');
        },
    });

    const offerClientFinalRefuseMutation=useMutation(offerClientFinalRefuse,{
        onSuccess: (res) => {
            SessionService.clearOrderIdentification();
            navigate('/');
        },
    });

    const body: OfferClientPreRefuseRequestBody|OfferClientFinalRefuseRequestBody = {
        id_zamowienia: id_zamowienia,
        oferta_id: oferta_id,
        token: isLoged ? null: SessionService.getTokenForUnlogedClient().token,

    }

    const handleSubmit = () => {
        isFinalOffer
        ? offerClientFinalRefuseMutation.mutate(body)
        : offerClientPreRefuseMutation.mutate(body);
    };


    if (offerClientFinalRefuseMutation.isLoading || offerClientPreRefuseMutation.isLoading) {
        return <LoadingBackDrop loading={true} />;
      }
    return (
        <Container
            onClick={handleSubmit}
        >
            <Icon
                width="15px"
                height="15px"
                noPadding
                icon={<ResignationIconSVG />}
            />
            <Description>Rezygnuję</Description>
        </Container >
    );
};

const Container = styled.button`
background-color:${theme.colors.gray04_background};
border:none;
display:flex;
flex-direction:row;
min-width:105px;
align-items: center;
background-color: transparent;
text-align: left;
cursor: pointer;
`;
const Description = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.normal};
font-size: 14px;
line-height: 20px;
color: ${theme.colors.gray01_secondaryText};
padding-left:8px;
`;
